<app-ticket-paper [company]="company">

  <div>
    Ticket N° {{ ticket.id_by_company?.toString().padStart(4, '0') }}
    @if(office) { &nbsp; {{ office.name }} }
  </div>
  <div>{{ ticket.date | date:'dd/MM/yyyy' }} &nbsp; {{ ticket.date | date:'HH:mm' }}</div>

  <div class="hr"></div>

  @for (detail of details; track detail.id) {
  <div class="row">
    <span class="desc">{{ detail.pivot?.quantity }}x {{ detail.pivot?.personalized_desc ?? detail.name }}</span>
    @if(!hidePrices) {
    <span [centToEurDisplay]="lineTotal(detail)"></span>
    }
  </div>
  }

  @if(!hidePrices) {
  <div class="hr"></div>

  <div class="row"><span>Subtotal</span><span [centToEurDisplay]="ticket.subtotal"></span></div>
  <div class="row"><span>IVA</span><span [centToEurDisplay]="ticket.total - ticket.subtotal"></span></div>
  <div class="row total-row"><span>TOTAL</span><span [centToEurDisplay]="ticket.total"></span></div>

  @if(ticket.payment_method) {
  <div class="hr"></div>

  @if(ticket.payment_method === 'mixto') {
    @for (mix of ticket.mix_pay; track $index) {
    <div class="row">
      <span>{{ getPaymentMethodLabel(mix.type) }}</span>
      <span [centToEurDisplay]="mix.quantity"></span>
    </div>
    }
  } @else {
    <div class="row">
      <span>{{ getPaymentMethodLabel(ticket.payment_method) }}</span>
      <span [centToEurDisplay]="ticket.total"></span>
    </div>
  }
  }
  }

  <div class="hr"></div>

  <div class="barcode">
    <div class="barcode-pattern"></div>
  </div>
  <div class="barcode-code">
    {{ ticket.id_by_company?.toString().padStart(4, '0') }}/{{ ticket.year }}
  </div>

  <div class="thanks">¡Gracias por su compra!</div>

</app-ticket-paper>
